<template>
    <div class="form">
        <h4 class="step-title">
            What is your current license status?
        </h4>
        <div class="step-content d-flex flex-column flex-md-row">
            <scrollable-button-list v-bind:items="licenseStatuses" v-bind:onclick="complete"/>
        </div>
    </div>
</template>

<script>
    import ScrollableButtonList from "./shared/ScrollableButtonList.vue"

    export default {
        name: "LicenseStatus",
        components: {
            ScrollableButtonList
        },
        data: function() {
            return {
                licenseStatuses: [
                    { text: "Valid", value: "Valid" },
                    { text: "Permit", value: "Permit" },
                    { text: "Expired", value: "Expired" },
                    { text: "Suspended", value: "Suspended" },
                    { text: "Revoked", value: "Revoked" },
                    { text: "None", value: "None" }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
            complete: function(licenseStatus) {
                this.lead.licenseStatus = licenseStatus;
                this.$emit("complete", this.$options.name, licenseStatus);
            }
        }
    }
</script>
